<div class="commercial-sale-infocard-wrapper">
    <div class="mini-infocard">
        <div class="header">
            <button class="three-dot"></button>
            <div class="description">
                <div class="title">
                    <h3>{{ selectedSale().streetAddress }}</h3>
                    @if (selectedSale().postalAddress) {
                    <h3>{{ selectedSale().postalAddress }}</h3>
                    }
                </div>
                <div class="subtitle">
                    <p>{{ selectedSale().estateSubTypeDescription }}</p>
                    <p>{{ selectedSale().cadastre | dash }}</p>
                </div>
            </div>
            <button class="close" (click)="close()"></button>
        </div>
        <div class="map-buttons">
            <button class="center-map" (click)="centerMap()">
                <div class="center-map-icon"></div>
                <span>Sentrer</span>
            </button>
            <button class="show-position" (click)="showInMap()">
                <div class="show-position-icon"></div>
                <span>Vis Posisjon</span>
            </button>
        </div>
        <mini-infocard-image-carousel [selectedSale]="selectedSale()" [imagePackages]="imagePackages()"></mini-infocard-image-carousel>
        @if (isCommercialSale()) {
        <commercial-sale-property-info [selectedSale]="selectedSale()"></commercial-sale-property-info>
        }@else{
        <residential-sale-property-info [selectedSale]="selectedSale()"></residential-sale-property-info>
        } @if (selectedSale().linkedSales?.length > 1 && isCommercialSale()) {
        <div class="linked-sales">
            <ev-accordion
                class="result-accordion"
                [animationFast]="true"
                [accordionHeight]="32"
                [buttonSize]="18"
                [buttonTopMargin]="7"
                [initExpanded]="false"
                data-test-tag="linked-sales-accordion"
            >
                <div header class="linked-sales-header paragraph">
                    <span class="linked-sales-header--title">Eiendommer som inngår</span>
                    <span class="counter">{{ selectedSale().linkedSales?.length }}</span>
                </div>
                <div body class="paragraph">
                    @for(linkedSale of selectedSale().linkedSales; track $index){
                    <div class="linked-sale-info" (click)="showSale(linkedSale)">
                        <div>{{ linkedSale.streetAddress }}</div>
                        @if (linkedSale.streetAddress != linkedSale.cadastre) {
                        <div>{{ linkedSale.cadastre }}</div>
                        }
                    </div>
                    }
                </div>
            </ev-accordion>
        </div>
        }
    </div>
</div>
